import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS from '../redux/actions/Page.js';
import * as UI_ACTIONS from '../redux/actions/UI.js';

import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
// import '@lottiefiles/lottie-player';
// import { Helmet } from 'react-helmet';

import NewFooter from '../components/NewFooter';

function mapStateToProps(state) {
  return {
    landing: state.Page.landing,
    article: state.Page.article,
    loading: state.Page.loading,
    loaded: state.Page.loaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLandingPage: bindActionCreators(ACTIONS.getLandingPage, dispatch),
    siteReady: bindActionCreators(UI_ACTIONS.siteReady, dispatch),
  };
}

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animIn: false,
      animOut: false,
      canvasActive: false,
      introOpen: false,
      lastTouchPos: null,
      videoLayer: null,
    };
  }

  initUnicorn = () => {
    const { landing } = this.props;
    const isMobile = window.innerWidth < 768;
    const UnicornStudio = window.UnicornStudio || {};
    console.log('UnicornStudio', UnicornStudio, this.props.landing);

    const endPoint = isMobile ? 'landing-m' : 'landing';

    UnicornStudio.addScene({
      elementId: 'unicorn-embed', // id of the HTML element to render your scene in (the scene will use its dimensions)
      fps: 60, // frames per second (0-120) [optional]
      scale: 1, // rendering scale, use smaller values for performance boost (0.25-1) [optional]
      dpi: 1.5, // pixel ratio [optional]
      // projectId: "YOUR_PROJECT_EMBED_ID", // the id string for your embed (get this from "embed" export)
      lazyLoad: true, // will not initialize the scene until it scrolls into view
      filePath: `https://2026--villagegreen-d82399.netlify.app/.netlify/functions/${endPoint}`, // if youre hosting your own exported json code, point to it here (do not use both filePath and projectId, only one is required)
      fixed: true, // whether the scene should behave like a fixed element or not. automatic by default but this gives explicit control
      altText: 'Welcome to Unicorn Studio', // optional text for SEO, going inside the <canvas> tag
      ariaLabel: 'This is a canvas scene', // optional text for the aria-label attribute on the <canvas> element
      production: true, // when true, will hit the global edge CDN, learn more in the help docs
    })
      .then((scene) => {
        console.log('UnicornStudio scene', scene);
        let videoFound = false;

        let startTimes = null;
        startTimes = isMobile
          ? landing.timestampsMobile || null
          : landing.timestamps || null;

        startTimes.push({ time: 0 });

        const randomStartTime = startTimes
          ? startTimes[Math.floor(Math.random() * startTimes.length)].time
          : 0;

        setTimeout(() => {
          scene.layers.forEach((layer) => {
            //console.log('layer', layer.getPlanes());

            layer.getPlanes().forEach((plane) => {
              if (plane.videos.length > 0) {
                const video = plane.videos[0];
                videoFound = true;
                console.log('video start', randomStartTime);
                video.currentTime = randomStartTime;

                setTimeout(() => {
                  // this.setState({ animIn: true });

                  setTimeout(() => {
                    this.setState({ canvasActive: true });
                  }, 1200);

                  setTimeout(() => {
                    this.setState({ animOut: true });
                  }, 1200);
                }, 500);
              }
            });
          });

          if (!videoFound) {
            // If no video found, still trigger the animations
            setTimeout(() => {
              // this.setState({ animIn: true });

              setTimeout(() => {
                this.setState({ canvasActive: true });
              }, 1200);

              setTimeout(() => {
                this.setState({ animOut: true });
              }, 1200);
            }, 500);
          }
        }, 500);
        // scene is ready
        // To remove a scene, you can use:
        // scene.destroy()
        // if the scenes container changes size and you need to resize the scene
        // scene.resize()
        // if you need to pause the scene
        // scene.paused = true;
        // if you need to resume the scene
        // scene.paused = false;
        // hide a layer
        // scene.layers[1].hide();
        // show a layer
        // scene.layers[1].show();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  handleMouseWheel = (e) => {
    if (!this.state.canvasActive) return; // Prevent scroll handling if canvas is active
    if (e.deltaY < 0) {
      // Scrolling down
      if (!this.state.introOpen) return;
      this.setState({ introOpen: false });
    } else {
      // Scrolling up
      if (this.state.introOpen) return;
      this.setState({ introOpen: true });
    }
  };

  handleTouchStart = (e) => {
    // if (!this.state.canvasActive) return; // Prevent touch handling if canvas is active
    const touch = e.touches[0];
    this.setState({ lastTouchPos: touch.clientY });
    // console.log('touch start', touch.clientY);
  };

  handleTouchMove = (e) => {
    // console.log('touch move', this.state.lastTouchPos);
    e.preventDefault(); // Prevent default touch behavior
    if (!this.state.canvasActive || this.state.lastTouchPos === null) return; // Prevent touch handling if canvas is active
    const touch = e.touches[0];

    const deltaY = this.state.lastTouchPos - touch.clientY;

    console.log('deltaY', deltaY);

    // show on swipe up, hide on swipe down

    // if (deltaY < -10) {
    //   // Swiping down
    //   if (this.state.introOpen) return;
    //   this.setState({ introOpen: true });
    // } else if (deltaY > 10) {
    //   // Swiping up
    //   if (!this.state.introOpen) return;
    //   this.setState({ introOpen: false });
    // }

    if (deltaY > 0) {
      // Swiping down
      if (this.state.introOpen) return;
      this.setState({ introOpen: true });
      // console.log('swiping down', 'show intro');
    } else if (deltaY < 0) {
      // Swiping up
      if (!this.state.introOpen) return;
      this.setState({ introOpen: false });
      // console.log('swiping up', 'hide intro');
    }

    // if (deltaY > 10) {
    //   // Swiping up
    //   if (!this.state.introOpen) return;
    //   this.setState({ introOpen: false });
    // } else if (deltaY < -10) {
    //   // Swiping down
    //   if (this.state.introOpen) return;
    //   this.setState({ introOpen: true });
    // }
    this.setState({ lastTouchPos: null });
  };

  componentDidMount() {
    this.props.getLandingPage();
    setTimeout(() => {
      this.setState({ animIn: true });
      this.initUnicorn();
    }, 600);

    document.documentElement.classList.add('is-landing');
    window.addEventListener('wheel', this.handleMouseWheel, { passive: true });
    window.addEventListener('touchmove', this.handleTouchMove, {
      passive: false,
    });
    window.addEventListener('touchstart', this.handleTouchStart, {
      passive: true,
    });
  }

  componentWillUnmount() {
    document.documentElement.classList.remove('is-landing');
    window.removeEventListener('wheel', this.handleMouseWheel);
    window.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('touchstart', this.handleTouchStart);
  }

  componentDidUpdate(prevProps) {
    this.props.siteReady();
  }

  render() {
    let { landing } = this.props;
    if (!landing) return null;

    const entry = landing;

    const cls = classNames({
      'is-anim-in': this.state.animIn,
      'is-anim-out': this.state.animOut,
    });

    const unicornCls = classNames('unicorn-embed', {
      'is-active': this.state.canvasActive,
    });

    const introCls = classNames('Landing-intro', {
      'is-open': this.state.introOpen,
    });

    const style = this.state.canvasActive ? null : { cursor: 'wait' };

    return (
      <div className="Template Template--landing" style={style}>
        <div className="Logo-anim">
          <h1 className={cls}>
            <span className="primary">Village Green</span>
            <span className="secondary">Village Green</span>
          </h1>
        </div>
        {/* <div className="lottie-container">
          <div>
            <lottie-player
              src="/ui/lottie/logo.json"
              autoplay
              mode="normal"
            ></lottie-player>
          </div>
        </div> */}
        <div className={unicornCls} id="unicorn-embed"></div>
        {/* <div
          className={unicornCls}
          data-us-project-src="https://2026--villagegreen-d82399.netlify.app/.netlify/functions/landing"
          data-us-scale="1"
          data-us-dpi="1.5"
          data-us-lazyload="false"
          data-us-alttext="Village Green"
          data-us-arialabel="This is a canvas scene"
        ></div> */}
        <div className={introCls}>
          <NewFooter entry={entry} />
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));



// WEBPACK FOOTER //
// ./src/js/templates/Home.js